
import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d3cptfkef3sotc9j6370', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Sanat Dünyasından Haberdar Olun
          </h2>
          <p className="text-xl text-gray-400 mb-8">
            Yeni koleksiyonlar, özel etkinlikler ve sanat dünyasındaki gelişmelerden 
            ilk siz haberdar olun. E-bültenimize abone olun.
          </p>

          {isSubmitted ? (
            <div className="bg-green-900/30 border border-green-700 rounded-lg p-6 max-w-md mx-auto">
              <div className="w-12 h-12 flex items-center justify-center bg-green-600 rounded-full mx-auto mb-4">
                <i className="ri-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-green-400 mb-2">Teşekkürler!</h3>
              <p className="text-green-300">E-bültenimize başarıyla abone oldunuz.</p>
            </div>
          ) : (
            <form 
              onSubmit={handleSubmit}
              data-readdy-form
              id="newsletter-form"
              className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresinizi girin"
                required
                className="flex-1 px-6 py-4 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white transition-colors text-sm"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-white text-black px-8 py-4 rounded-lg font-semibold hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Abone Ol'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}